
<template>
    <div class="resumo-component">
        <div class="fixed-info-resumo">
            <h1>Resumo Consolidado</h1>
            <div class="info-section">
                <div class="info-column">
                    <h4><strong>Valores Financeiros Totais</strong></h4>
                    <table>
                        <tbody>
                        <tr>
                            <td>Total de Despesas:</td>
                            <!-- <td>{{ 'R$ ' + totalDespesas.toFixed(2) }} </td> -->
                            <td>{{ formatCurrency(totalDespesas) }}</td>
                        </tr>
                        <tr>
                            <td>Total de Rendimentos:</td>
                            <td>{{ formatCurrency(totalRendimentos) }}</td>
                        </tr>
                        <tr>
                            <td>Total de Receitas Diversas:</td>
                            <td> {{ formatCurrency(totalReceitasDiversas) }}</td>
                        </tr>
                        <tr>
                            <td>Total de Contrapartidas Econômicas:</td>
                            <td> {{ formatCurrency(totalContrapartidasEconomicas) }}</td>
                        </tr>
                        <tr>
                            <td>Total de Contrapartidas Financeiras:</td>
                            <td> {{ formatCurrency(totalContrapartidasFinanceiras) }}</td>
                        </tr>
                        <tr>
                            <td><strong>Valor Final:</strong></td>
                            <td><strong> {{ formatCurrency(valorFinal)}}</strong></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="info-column">
                    <h4><strong>Informações de Prazos e Datas</strong></h4>
                    <table>
                        <tbody>
                        <tr>
                            <td>Prazo Total Médio:</td>
                            <td>{{ prazoTotalMedio ? prazoTotalMedio.toFixed(2) : 0 }} dia(s)</td>
                        </tr>
                        <tr>
                            <td>Período Total:</td>
                            <td><span v-if="periodoDuracaoInicial && periodoDuracaoFinal" >{{
                                        periodoDuracaoInicial
                                        ? $moment(periodoDuracaoInicial).format(
                                            'DD/MM/YYYY'
                                        )
                                        : ''
                                }}
                                <span>a</span>
                                {{
                                        periodoDuracaoFinal
                                        ? $moment(periodoDuracaoFinal, "DD/MM/YYYY HH:mm:ss").format(
                                            'DD/MM/YYYY'
                                        )
                                        : ''
                                }}</span></td>
                        </tr>
                        <tr>
                            <td>Duração Total:</td>
                            <td>{{ duracaoTotal ? duracaoTotal : 0 }} dia(s)</td>
                        </tr>
                        <tr>
                            <td>Quantidade de Prestações de Contas:</td>
                            <td>{{ quantidadePrestacoesContas }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {

     props: {
        convenio: {
            type: Object,
            required: true
        },
        prestacoes: {
            type: Array,
            default: () => []
        },
        quantidadePrestacoesContas: 0,
        tempoMedioEntreEtapas: 0,
        duracaoTotal: '',
        periodoDuracaoInicial: '',
        periodoDuracaoFinal: '',
        prazoTotalMedio: 0
    },

    methods: {
        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        }
    },

    computed: {
        totalDespesas() {
            return this.prestacoes.reduce((soma, prestacao) => soma + (prestacao.nuTotalGasto || 0), 0);
        },

        totalRendimentos() {
            return this.prestacoes.reduce((soma, prestacao) => soma + (prestacao.nuTotalRendimentos || 0), 0);
        },

        totalReceitasDiversas() {
            return this.prestacoes.reduce((soma, prestacao) => soma + (prestacao.nuReceitasDiversas || 0), 0);
        },

        totalContrapartidasEconomicas() {
            return this.prestacoes.reduce((soma, prestacao) => soma + (prestacao.valorContraPartidaEconomica || 0), 0);
        },

        totalContrapartidasFinanceiras() {
            return this.prestacoes.reduce((soma, prestacao) => soma + (prestacao.valorContraPartidaFinanceira || 0), 0);
        },

        valorFinal() {
            return (
                this.totalRendimentos +
                this.totalReceitasDiversas +
                this.totalContrapartidasEconomicas +
                this.totalContrapartidasFinanceiras -
                this.totalDespesas
            );
        }
    },

  }
</script>

<style scoped>
.resumo-component {
  margin-top: 20px;
}

.fixed-info-resumo h1 {
background-color: #f9f9f9;
margin: 0;
padding: 15px;
font-size: 1.5em;
font-weight: bold;
border-bottom: 1px solid #ddd;
text-align: left;
}

.fixed-info-resumo {
border: 1px solid #ddd;
border-radius: 10px;
overflow: hidden;
}

.fixed-info-resumo .info-section {
background-color: #ffffff;
padding: 15px 20px;
display: grid;
grid-template-columns: 1fr 1fr;
row-gap: 10px;
}

.fixed-info-resumo .info-item {
font-size: 1em;
}

.fixed-info-resumo .info-item strong {
font-weight: bold;
}

.column-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  padding-bottom: 5px;
  border-bottom: 2px solid #333;
  margin-bottom: 15px;
}

.info-section {
  display: flex;
  gap: 20px;
}

.info-column {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.info-item {
  margin-bottom: 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

td:first-child {
  font-weight: bold;
}

@media (max-width: 768px) {
  .fixed-info-resumo .info-section {
    grid-template-columns: 1fr;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  h4 {
    font-size: 1.3em;
    text-align: left;
  }
}

</style>
